<style src="vue-select/dist/vue-select.css"></style>
<style>
.table-hover {
    width: 100%;
    table-layout: fixed;
}

.table-sm {
    font-size: 14px;
}
</style>

<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">

                        <!-- HEADER -->
                        <div class="card-header">
                            <h3 class="card-title">
                                REKAP CLOSING PAYMENT ONLINE
                            </h3>
                        </div>

                        <!-- BODY -->
                        <div class="card-body p-2">
                            <div class="row mb-2">
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="form-group mb-2">
                                        <MonthPicker v-model="filter.periode" label="Periode" @input="onFilterChange"
                                            class="custom-input" />
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                    <div class="form-group mb-2">
                                        <KantorCabang v-model="filter.kantor" label="Cabang" @input="onFilterChange"
                                            class="custom-input" />
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive-wrapper">
                                <v-data-table :headers="headers" :items="usersGrouped" :loading="loading"
                                    :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                                    :server-items-length="totalItems"
                                    :footer-props="{ itemsPerPageOptions: [50, 100, 200] }" @update:page="fetchUsers"
                                    @update:items-per-page="changeItemsPerPage" class="rekap-table">

                                    <template #item="{ item, index }">
                                        <tr>
                                            <td v-if="item.showNo" :rowspan="item.rowspan"
                                                class="text-center align-middle col-no">
                                                {{ (pagination.page - 1) * pagination.itemsPerPage + item.no }}
                                            </td>
                                            <td class="col-cabang">
                                                {{ item.cabang }}
                                                <span v-if="item.tipe_langganan != 1"
                                                    class="badge-corporate">CORPORATE</span>
                                            </td>
                                            <td class="text-center col-invoice">{{ item.total_invoice }}</td>
                                            <td class="text-right col-paid">{{ formatRupiah(item.total_paid) }}</td>
                                            <td class="text-center col-periode">{{ item.bulan_pemakaian }}</td>
                                            <td class="text-center col-aksi">
                                                <button class="btn btn-xs btn-info" title="Detail rekap"
                                                    @click="openUserDetail(item)">
                                                    <i class="fas fa-search"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>

                                    <template v-slot:body.append>
                                        <tr class="row-total">
                                            <!-- No + Cabang digabung jadi label TOTAL -->
                                            <td colspan="2" class="row-total-label">TOTAL</td>
                                            <!-- sejajar kolom Jml Invoice -->
                                            <td class="row-total-invoice">{{ totalInvoice }}</td>
                                            <!-- sejajar kolom Total PAID -->
                                            <td class="row-total-paid">{{ formatRupiah(totalPaid) }}</td>
                                            <!-- sejajar kolom Periode + Aksi -->
                                            <td colspan="2"></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formatRupiah } from '../../helpers/format'
import MonthPicker from '../../base-components/MonthPicker.vue'
import KantorCabang from '../../base-components/KantorCabang.vue'
import { EventBus } from './../../event-bus'
import Detail_Rekap_closing_online from './Detail_Rekap_closing_online.vue'

export default {
    components: {
        MonthPicker,
        KantorCabang
    },

    data() {
        return {
            filter: {
                periode: new Date().toISOString().slice(0, 7),
                kantor: null
            },

            users: [],
            totalItems: 0,
            loading: false,

            pagination: {
                page: 1,
                itemsPerPage: 50
            },

            headers: [
                { text: 'No', value: 'no', sortable: false, align: 'center', width: '40px' },
                { text: 'Cabang', value: 'cabang', sortable: true },
                { text: 'Jml Invoice', value: 'total_invoice', sortable: true, align: 'center', width: '80px' },
                { text: 'Total PAID', value: 'total_paid', sortable: true, align: 'right' },
                { text: 'Periode', value: 'bulan_pemakaian', sortable: true, align: 'center', width: '90px' },
                { text: 'Aksi', value: 'actions', sortable: false, align: 'center', width: '50px' }
            ]
        }
    },

    computed: {
        totalInvoice() {
            return this.users.reduce((sum, item) => {
                return sum + Number(item.total_invoice || 0)
            }, 0)
        },

        totalPaid() {
            return this.users.reduce((sum, item) => {
                return sum + Number(item.total_paid || 0)
            }, 0)
        },

        usersGrouped() {
            let result = [];
            let no = 1;
            let currentCabang = null;
            let currentGroupIndex = -1;

            this.users.forEach(item => {
                if (item.cabang !== currentCabang) {
                    currentCabang = item.cabang;
                    currentGroupIndex = result.length;
                    result.push({
                        ...item,
                        showNo: true,
                        rowspan: 1,
                        no: no++
                    });
                } else {
                    currentCabang = item.cabang;
                    currentGroupIndex = result.length;
                    result.push({
                        ...item,
                        showNo: true,
                        rowspan: 1,
                        no: no++
                    });
                }
            });

            return result;
        }
    },

    mounted() {
        this.fetchUsers()
    },

    methods: {
        formatRupiah,

        onFilterChange() {
            this.pagination.page = 1
            this.fetchUsers()
        },

        async fetchUsers() {
            this.loading = true
            try {
                const res = await axios.get('api/keuangan/rekap_closing_online', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        periode: this.filter.periode,
                        kantor_id: this.filter.kantor?.id || null
                    }
                })

                this.users = res.data.data
                this.totalItems = res.data.total
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },

        changeItemsPerPage(perPage) {
            this.pagination.itemsPerPage = perPage
            this.pagination.page = 1
            this.fetchUsers()
        },

        openUserDetail(item) {
            EventBus.$emit('modal:show', {
                title: `Detail Rekap Closing Invoice [${item.cabang}]`,
                component: Detail_Rekap_closing_online,
                props: {
                    data: {
                        ...item,
                        periode: item.periode || this.filter.periode,
                        kantor_id: item.kantor_id || this.filter.kantor?.id || null
                    }
                },
                width: '1200px',
                key: Date.now()
            })
        }
    }
}
</script>

<style scoped>
/* Wrapper agar tabel bisa scroll horizontal di mobile */
.table-responsive-wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

/* Paksa table-layout fixed agar kolom sejajar antara header, body, dan total */
.rekap-table table {
    table-layout: fixed !important;
    width: 100% !important;
}

/* Lebar kolom sesuai header width */
.rekap-table table colgroup col:nth-child(1) {
    width: 40px !important;
}

.rekap-table table colgroup col:nth-child(3) {
    width: 80px !important;
}

.rekap-table table colgroup col:nth-child(5) {
    width: 90px !important;
}

.rekap-table table colgroup col:nth-child(6) {
    width: 50px !important;
}

/* Badge CORPORATE */
.badge-corporate {
    display: inline-block;
    font-size: 10px;
    background-color: #d1ecf1;
    color: #0c5460;
    padding: 1px 5px;
    border-radius: 3px;
    margin-left: 4px;
    white-space: nowrap;
}

/* Baris total */
.row-total td {
    border-top: 2px solid #dee2e6 !important;
    background-color: #f8f9fa !important;
    padding: 10px 12px !important;
    vertical-align: middle !important;
}

.row-total-label {
    font-size: 16px !important;
    font-weight: bold !important;
    text-align: left !important;
    padding-left: 16px !important;
}

.row-total-invoice {
    font-size: 16px !important;
    font-weight: bold !important;
    text-align: center !important;
    width: 80px !important;
}

.row-total-paid {
    font-size: 16px !important;
    font-weight: bold !important;
    text-align: right !important;
    white-space: nowrap !important;
}

/* =====================
   RESPONSIVE MOBILE
   ===================== */
@media (max-width: 768px) {

    /* Semua cell — kurangi padding */
    .v-data-table td,
    .v-data-table th {
        padding: 6px 5px !important;
        font-size: 12px !important;
    }

    /* Kolom No */
    .col-no {
        width: 28px !important;
        min-width: 28px !important;
        max-width: 28px !important;
        padding: 6px 3px !important;
        font-size: 11px !important;
    }

    /* Kolom Cabang — bisa wrap */
    .col-cabang {
        min-width: 100px !important;
        white-space: normal !important;
        word-break: break-word;
        line-height: 1.3;
    }

    /* Kolom Jumlah Invoice */
    .col-invoice {
        width: 55px !important;
        min-width: 55px !important;
        text-align: center !important;
    }

    /* Kolom Total Paid — jangan wrap angka */
    .col-paid {
        min-width: 105px !important;
        white-space: nowrap;
        text-align: right !important;
        font-size: 11px !important;
    }

    /* Kolom Periode */
    .col-periode {
        width: 68px !important;
        min-width: 68px !important;
        white-space: nowrap;
        font-size: 11px !important;
    }

    /* Kolom Aksi */
    .col-aksi {
        width: 38px !important;
        min-width: 38px !important;
        padding: 6px 3px !important;
    }

    /* Baris total di mobile */
    .row-total td {
        padding: 8px 5px !important;
    }

    .row-total-label {
        font-size: 12px !important;
        padding-left: 8px !important;
    }

    .row-total-invoice {
        font-size: 12px !important;
    }

    .row-total-paid {
        font-size: 11px !important;
    }

    /* Header tabel */
    .v-data-table-header th {
        font-size: 11px !important;
        padding: 6px 5px !important;
        white-space: nowrap;
    }

    /* Footer pagination */
    .v-data-footer {
        font-size: 11px !important;
        padding: 4px 8px !important;
        flex-wrap: wrap;
    }

    .v-data-footer__select {
        margin: 4px 0 !important;
    }
}
</style>